<template>
    <div id="wrapper" v-if="expanded">
        <label>Language:</label>
        <select id="master-select" v-model="languageName">
            <option v-for="language in availableLanguages" :key="language.code" :value="language.name">{{ language.name }}</option>
        </select>
        <p role="alert" :class="[isValid ? 'no-error' : '']">You've already added this language</p>
        <p role="alert" :class="[isInit ? 'no-error' : '']">Please select a language</p>
        <hr/>
        <div class="editable">
            <div class="accolade">
                <label>Speaking:</label><input type="range" v-model.number="speaking" :class="cefr[speaking]" min="1" max="6"/>
            </div>
            <div class="accolade">
                <label>Writing:</label><input type="range" v-model.number="writing" :class="cefr[writing]" min="1" max="6"/>
            </div>
            <div class="accolade">
                <label>Reading:</label><input type="range" v-model.number="reading" :class="cefr[reading]" min="1" max="6"/>
            </div>
            <div class="accolade">
                <label>Listening:</label><input type="range" v-model.number="listening" :class="cefr[listening]" min="1" max="6"/>
            </div>
            <div class="accolade">
                <label>Grammar:</label><input type="range" v-model.number="grammar" :class="cefr[grammar]" min="1" max="6"/>
            </div>
        </div>
        <hr/>
        <div id="submission"><button id="confirm" @click="saveLanguage()" :class="[unsaved ? 'errored' : '']">Confirm</button>
                             <button id="cancel" @click="expandRequest(false)">Cancel</button>
                             <button id="remove" @click="removeLanguage()">Remove</button></div>
    </div>
    <div id="wrapper" v-else @click="expandRequest(true)">
        <h2>{{ languageNameSt }}</h2>
        <hr/>
        <div class="accolades">
            <div class="accolade">
                <dt>Speaking:</dt><dd :class="cefr[speakingSt]">{{ cefr[speakingSt] }}</dd>
            </div>
            <div class="accolade">
                <dt>Writing:</dt><dd :class="cefr[writingSt]">{{ cefr[writingSt] }}</dd>
            </div>
            <div class="accolade">
                <dt>Reading:</dt><dd :class="cefr[readingSt]">{{ cefr[readingSt] }}</dd>
            </div>
            <div class="accolade">
                <dt>Listening:</dt><dd :class="cefr[listeningSt]">{{ cefr[listeningSt] }}</dd>
            </div>
            <div class="accolade">
                <dt>Grammar:</dt><dd :class="cefr[grammarSt]">{{ cefr[grammarSt] }}</dd>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineProps,computed,ref,watch,defineEmits } from 'vue';
    import { languageStore } from '@/stores/languages';

    const props = defineProps({
        available:Array,
        index:Number,
        unsaved:Boolean
    });

    const emits = defineEmits(['saved']);

    const language = computed(() => {return languageStore().languages[props.index] || null;});
    var usedLanguages = languageStore().usedLanguages;

    const languageNameSt = computed(() => language.value.name);
    const writingSt = computed(() => language.value.writing);
    const readingSt = computed(() => language.value.reading);
    const speakingSt = computed(() => language.value.speaking);
    const listeningSt = computed(() => language.value.listening);
    const grammarSt = computed(() => language.value.grammar);
    const expanded = computed(() => language.value.expanded);
    const draft = computed(() => language.value.draft);
    const availableLanguages = computed(() => props.available);

    var languageName = ref("");
    var writing = ref(1);
    var reading = ref(1);
    var speaking = ref(1);
    var listening = ref(1);
    var grammar = ref(1);

    watch(() => languageStore().languages[props.index]?.expanded,(newExpanded) =>{
        if(language.value && newExpanded !== undefined)
        {
            if(languageStore().languages[props.index].expanded)
            {
                languageName.value = languageNameSt.value;
                writing.value = writingSt.value;
                reading.value = readingSt.value;
                speaking.value = speakingSt.value;
                listening.value = listeningSt.value;
                grammar.value = grammarSt.value;
            }
        }
        
        else return;
    },{immediate:true});

    const unsaved = computed(() => {
        if(!props.unsaved) return false;

        else
        {
            if(languageStore().languages[props.index]?.expanded) return true;
            else return false;
        }
    });
    
    const oldValues = [languageName.value,writing.value,reading.value,speaking.value,listening.value,grammar.value];
    
    const cefr = ['cefr','A1','A2','B1','B2','C1','C2'];

    const isValid = ref(true),isInit = ref(true);

    const expandRequest = (a) =>
    {
        if(a) languageStore().expandRequest(props.index,true); 

        else
        {
            if(draft.value) languageStore().removeLanguage(props.index);

            else
            {
                languageName.value = oldValues[0];
                writing.value = oldValues[1];
                reading.value = oldValues[2];
                speaking.value = oldValues[3];
                listening.value = oldValues[4];
                grammar.value = oldValues[5];
                languageStore().expandRequest(props.index,false);
            }
            
        }
        usedLanguages = languageStore().usedLanguages;
        emits('saved');
    }

    const saveLanguage = () => {
        isInit.value = languageName.value != "Select"
        isValid.value = !usedLanguages.includes(languageName.value);
        if(isValid.value && isInit.value) 
        {
            languageStore().saveLanguage(props.index,languageName.value,writing.value,reading.value,speaking.value,listening.value,grammar.value);
            usedLanguages = languageStore().usedLanguages;
        }
        emits('saved');
    }

    const removeLanguage = () => {
        languageStore().removeLanguage(props.index);
        emits('saved');
        }
</script>

<style scoped>
    #wrapper
    {
        width:90%;
        background-color: #fff8f2;
        border-radius: 12px;
        padding:2%;
        padding-top:1%;
    }

    .accolades,.editable
    {
        display:flex;
        flex-wrap: wrap;
        gap:8px;
        padding:5px 0;
    }

    .editable
    {
        gap:22px;
    }

    .accolade
    {
        display: flex;
        gap:2px;
        align-items: center;
    }

    .editable .accolade
    {
        width:98%;
    }

    #submission
    {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 8px;
    }

    dt,dd
    {
        width:auto;
        margin:0;
    }

    p
    {
        color:#f5845e;
    }

    p.no-error
    {
        display:none;
    }

    hr
    {
        border:1px solid black;
    }

    h2,dt,dd,label,select
    {
        font-family: Playfair Display;
        color:black;
    }

    dt,dd
    {
        font-size: 18px;
    }

    label,.accolade select
    {
        font-size: 20px;
    }

    dt,label,h2
    {
        user-select: none;
    }

    dd
    {
        text-shadow: 0px 1px 4px rgb(0 0 0 / 80%);
    }

    select
    {
        font-weight: bold;
        background: none;
        border:none;
        appearance: none;
        cursor: pointer;
        border-bottom:2px solid black;
    }

    input[type=range]
    {
        -webkit-appearance: none;
        appearance: none;
        width:100%;
        height:5px;
        background-color:#C0BBAF;
        transition: background-color 0.3s;
    }

    input[type=range]::-webkit-slider-thumb
    {
        appearance: none;
        -webkit-appearance: none;
    }

    input[type=range]::-webkit-slider-thumb
    {
        width:40px;
        height:40px;
        cursor:pointer;
    }

    input[type=range]::-moz-range-thumb
    {
        width:40px;
        height:40px;
        cursor:pointer;
    }

    input[type=range]:hover
    {
        background-color: rgb(230, 228, 224);
    }

    dd
    {
        font-weight: bold;
    }

    #master-select
    {
        margin:12px 0;
        font-size: 22px;
    }

    button
    {
        font-family: Playfair Display;
        font-size: 20px;
        cursor:pointer;
    }

    #cancel
    {
        background: none;
        border:none;
        text-decoration: underline;
    }

    #cancel:hover,#remove:hover
    {
        text-decoration: none;
    }

    #confirm
    {
        background:none;
        color:black;
        border:2px solid black;
        border-radius: 20px;
        padding:4px 8px;
    }

    #confirm:hover
    {
        background: #C0BBAF50;
        text-decoration: underline;
    }

    #remove
    {
        background: none;
        border:none;
        text-decoration: underline;
        color:#f66e41;
    }

    .errored
    {
        border:2px solid red !important; 
    }

    input[type=range].A1::-webkit-slider-thumb
    {
        background:#5ef566;
        background-image: url('@/assets/cefr/A1.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].A1::-moz-range-thumb
    {
        background:#5ef566;
        background-image: url('@/assets/cefr/A1.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].A2::-webkit-slider-thumb
    {
        background:#b1f55e;
        background-image: url('@/assets/cefr/A2.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].A2::-moz-range-thumb
    {
        background:#b1f55e;
        background-image: url('@/assets/cefr/A2.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].B1::-webkit-slider-thumb
    {
        background:#d7f55e;
        background-image: url('@/assets/cefr/B1.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].B1::-moz-range-thumb
    {
        background:#d7f55e;
        background-image: url('@/assets/cefr/B1.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].B2::-webkit-slider-thumb
    {
        background:#f5e85e;
        background-image: url('@/assets/cefr/B2.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].B2::-moz-range-thumb
    {
        background:#f5e85e;
        background-image: url('@/assets/cefr/B2.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].C1::-webkit-slider-thumb
    {
        background:#f5845e;
        background-image: url('@/assets/cefr/C1.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].C1::-moz-range-thumb
    {
        background:#f5845e;
        background-image: url('@/assets/cefr/C1.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].C2::-webkit-slider-thumb
    {
        background:#f55e9d;
        background-image: url('@/assets/cefr/C2.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    input[type=range].C2::-moz-range-thumb
    {
        background:#f55e9d;
        background-image: url('@/assets/cefr/C2.jpg');
        background-size:     cover;
        background-repeat:   no-repeat;
        background-position: center center;  
    }

    dd.A1
    {
        color:#5ef566;
    }

    dd.A2
    {
        color:#b1f55e;
    }

    dd.B1
    {
        color:#d7f55e;
    }

    dd.B2
    {
        color:#f5e85e;
    }

    dd.C1
    {
        color:#f5845e;
    }

    dd.C2
    {
        color:#f55e9d;
    }

    @media (max-width:300px)
    {
        #master-select
        {
            margin:7px 0;
            font-size: 18px;
        }

        button
        {
            font-size: 16px;
        }

        label,dt,dd
        {
            font-size: 16px;
        }

        input[type=range]::-webkit-slider-thumb
        {
            width:30px;
            height:30px;
        }

        input[type=range]::-moz-range-thumb
        {
            width:30px;
            height:30px;
        }

        .editable
        {
            gap:14px;
        }
    }

    @media (max-width:240px)
    {
        label
        {
            font-size: 12px;
        }
    }

    @media (max-height:480px)
    {
        #master-select
        {
            margin:7px 0;
            font-size: 18px;
        }

        button
        {
            font-size: 16px;
        }

        label,dt,dd
        {
            font-size: 16px;
        }

        input[type=range]::-webkit-slider-thumb
        {
            width:30px;
            height:30px;
        }

        input[type=range]::-moz-range-thumb
        {
            width:30px;
            height:30px;
        }

        .editable
        {
            gap:14px;
        }

        h2
        {
            font-size: 20px;
        }
    }
</style>